// eslint-no-undef
import React from 'react';
import ProfileMenu from './ProfileMenu';
import '../App.css';
import {Client} from '@stomp/stompjs';

export default class ProfileWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = {showMenu: false};
  }

  componentDidMount() {
    let that = this;
    const currentLoc = window.location.href;
    let hostname = window.location.hostname;
    if (hostname === 'ugov.co') {
      hostname = 'staging.ugov.co';
    }
    let url = `${ ( currentLoc.indexOf('localhost') !== -1 || currentLoc.indexOf('dev') !== -1 ) ? 'ws' : 'wss'}://${window.location.host}/ws`;
    // note - staging.ugov.co is a hack because that's the current vhost in rabbitmq...
    let client = new Client({
      brokerURL: url,
      connectHeaders: {
        login: 'guest',
        passcode: 'guest',
        host: hostname,
        saslMechanism: 'ANONYMOUS'
      },
      debug: function(str) {
        console.log('STOMP DEBUG: ' + str)
      },
      heartbeatIncoming: 0,
      heartbeatOutgoing: 5000,
      reconnectDelay: 1000,
      onStompError: (frame) => {
        console.log('STOMP: Got ERROR: ' + JSON.stringify(frame));
      }
    });
    document.CLIENT = client;
    client.onConnect = (frame) => {
      console.log('STOMP: Got connect: ' + JSON.stringify(frame));
      let stompTopics = [
        `/chat_q/user_${that.props.user.stomp_key}`,
        `/area_q/area_${that.props.user.area_id['$oid']}`,
        `/notification_q/user_${that.props.user.stomp_key}`,
        // `/topic/chat_q`,
        // `/topic/area_q`,
        // `/topic/notification_q`
      ];
      for (let i = 0; i < stompTopics.length; i++) {
        client.subscribe(stompTopics[i], function(message) { that.handleMessage(message, that) });
      }
    }
    client.activate();
  }

  toggleMenu() {
    console.log('toggle menu...');
    if (this.state.showMenu) {
      this.setState({showMenu: false});
    } else {
      this.props.app.setState({showNotificationMenu: false});
      this.setState({showMenu: true});
    }
  }

  handleVoteMessage(msg) {
    let vote = msg.notification.vote;
    let originator = vote.user;   // eslint-disable-line
    if (this.props.app && this.props.app._notificationMenu) {
      let notifications = this.props.app._notificationMenu.state.notifications || [];
      notifications.unshift(msg.notification);
      let counter = this.props.app.state.notificationCounter || 0;
      this.props.app._notificationMenu.setState({notifications: notifications});
      this.props.app.setState({notificationCounter: (counter + 1)});
    }
  }

  handleCommentMessage(msg) {
    let comment = msg.notification.comment;
    let originator = comment.user;   // eslint-disable-line
    if (this.props.app && this.props.app._notificationMenu) {
      let notifications = this.props.app._notificationMenu.state.notifications || [];
      notifications.unshift(msg.notification);
      let counter = this.props.app.state.notificationCounter || 0;
      this.props.app._notificationMenu.setState({notifications: notifications});
      this.props.app.setState({notificationCounter: (counter + 1)});
    }
  }

  markNotificationRead(notification) {
    let notificationId = notification._id['$oid'];
    let url = window.location.protocol + '//' + window.location.host;
    let seenParams = {
      uri: `${url}/api/v1/notifications/${notificationId}`,
      method: 'PUT',
    };
    try {
      fetch(seenParams.uri, seenParams, function(err, data) {
        if (err) {
          console.log('Voting error: ' + err);
        } else {
          // Got a valid response?
          console.log('Marked notification with id: ' + notificationId + ' as seen.');
        }
      });
    } catch(e) {
      console.log('[Error] marking notification as seen: ' + e);
    }
  }

  handleChatMessage(msg) {
    let newMessage = msg.message;
    let conversation = undefined;
    newMessage.user = msg.user;
    let found = false;
    if (this.props.app && this.props.app._conversationPage && this.props.app._conversationPage._messageViewer ) {
      // Message is for an active conversation...
      let messageViewer = this.props.app._conversationPage._messageViewer;
      if (this.props.app.state.conversation._id.$oid === newMessage.conversation_id['$oid']) {
        found = true;
        let messages = messageViewer.state.messages;
        messages.unshift(newMessage);
        messageViewer.setState({messages: messages}, messageViewer.scrollToBottom);
        // Now find the convo and update its title...
        conversation = this.props.app.state.conversation;
        if (typeof newMessage === 'object') {
          if (typeof newMessage.body === 'object') {
            messageViewer.setState({title: newMessage.body.title});
            newMessage.body = newMessage.body.text;
            conversation['title'] = newMessage.body.title;
          }
          conversation['latest_message'] = newMessage;
        }
        // Mark the notification for this message as seen
        if (msg.notification) {
          this.markNotificationRead(msg.notification);
        }
        this.props.app.setState({conversation: conversation});
      } else if (this.props.app.state && this.props.app.state.conversations) {
        let foundConvo = false;
        let conversations = this.props.app.state.conversations;
        for (let i = 0; i < conversations.length; i++) {
          let convo = conversations[i];
          if (newMessage.conversation_id['$oid'] === convo._id['$oid']) {
            convo['latest_message'] = newMessage;
            if (!found) {
              convo['unreadMessage'] = true;
            }
            foundConvo = true;
            break;
          }
        }
        if (!foundConvo) {
          // New conversation div...
          let convo = msg.conversation;
          if (!convo['latest_message']) {
            convo['latest_message'] = newMessage;
          }
          convo.user = msg.user;
          convo['unreadMessage'] = true;
          conversations.unshift(convo);
        }
        this.props.app.setState({conversations: conversations});
      }
    }
    if (!found) {
      // Update the little countery thingy above the chat div.
      let counter = this.props.app.state.messageCounter || 0;
      this.props.app.setState({messageCounter: counter + 1});
    }
  }

  handlePollResponse(msg) {
    if (this.props.app && this.props.app._notificationMenu) {
      let notifications = this.props.app._notificationMenu.state.notifications || [];
      notifications.unshift(msg.notification);
      let counter = this.props.app.state.notificationCounter || 0;
      this.props.app._notificationMenu.setState({notifications: notifications});
      this.props.app.setState({notificationCounter: (counter + 1)});
    }
  }

  handleMessage(msg, handler) {
    let message = JSON.parse(msg.body);
    if (message.message) {
      handler.handleChatMessage(message);
    } else if (message.notification && message.notification.vote) {
      handler.handleVoteMessage(message);
    } else if (message.notification && message.notification.comment) {
      handler.handleCommentMessage(message);
    } else if (message.notification && message.notification.poll_response_count) {
      handler.handlePollResponse(message);
    } else {
      // Posts perhaps?
      console.log('Do not know what to do with this notification: ' + JSON.stringify(message.notification));
    }
  }

  render() {
    return (
      <div className='profile'>
        <img className='avatarRight' onClick={this.toggleMenu.bind(this)} src={this.props.avatar} alt='' />
        { this.state.showMenu ? <ProfileMenu app={this.props.app} user={this.props.user} username={this.props.username} avatar={this.props.avatar} /> : '' }
      </div>
    );
  }
}
